import React, { useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { usePagesState, TermsAndcondition } from '../../context/PagesContext';


//global css
import "../../static/css/global.css";

const Termsandcondition = () => {
  const context = usePagesState();


  useEffect(() => {
    TermsAndcondition(context.setTerms)
  }, []);

  useEffect(() => {
    if (context.Terms.Terms.data && context.Terms.Terms.data.content) {
      let htmlData = context.Terms.Terms.data.content;
      document.getElementById("content").innerHTML = htmlData;
    }
  }, [context.Terms.Terms.data])



  return (
    <>
      <div className='maincontent'>
        <div className='content' id='content'>
        </div>
      </div>
    </>
  );

}

export default withRouter(Termsandcondition);